import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import EmptyLeasePage from './component';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => ({
  propertyId,
  rentalProtectionDisclaimers: state.payments.landlord.property.rentalProtectionDisclaimers,
  listingAlias: state.payments.landlord.property.listingAlias,
});

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  goToSetupPaymentManually: () =>
    Promise.resolve().then(() => dispatch(push(baseUrl + paths.onboarding.areYouSurePage))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmptyLeasePage);
